/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../_metronic/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../_metronic/helpers'
import {
  deleteHawala,
  confirmHawala,
  rejectHawala,
  setHawalaUnderProcess,
} from '../../core/_requests'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {FormattedMessage} from 'react-intl'
import toast from 'react-hot-toast'
import Swal from 'sweetalert2'
import {Hawala} from '../../core/_models'

type Props = {
  hawala: Hawala
}

const HawalaActionsCell: FC<Props> = ({hawala}) => {
  const id = hawala.id
  const status = hawala.status
  const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const deleteItem = useMutation(() => deleteHawala(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('حواله با موفقیت حذف شد')
    },
    onError: () => {
      toast.error('خطا هنگام حذف حواله')
    },
  })

  const confirmDelete = async () => {
    const result = await Swal.fire({
      title: 'آیا مطمئن هستید؟',
      text: 'این عملیات قابل بازگشت نیست!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'بله، حذف کن!',
    })

    if (result.isConfirmed) {
      deleteItem.mutate()
    }
  }

  const confirmResellerHawala = useMutation(() => confirmHawala(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('حواله تأیید شد')
    },
    onError: () => {
      toast.error('تأیید حواله با خطا مواجه شد')
    },
  })

  const confirmingHawala = async () => {
    const result = await Swal.fire({
      title: 'تأیید حواله؟',
      text: 'آیا می‌خواهید این حواله را تأیید کنید؟',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله، تأیید کن!',
    })

    if (result.isConfirmed) {
      confirmResellerHawala.mutate()
    }
  }

  const rejectResellerHawala = useMutation((reason: string) => rejectHawala(id, reason), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('حواله رد شد')
    },
    onError: () => {
      toast.error('رد کردن حواله با خطا مواجه شد')
    },
  })

  const confirmReject = async () => {
    const result = await Swal.fire({
      title: 'رد کردن حواله؟',
      text: 'آیا می‌خواهید این حواله را رد کنید؟',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله، رد کن!',
    })

    if (result.isConfirmed) {
      const {value: rejectReason} = await Swal.fire({
        title: 'دلیل رد را وارد کنید',
        input: 'text',
        inputPlaceholder: 'دلیل رد حواله...',
        showCancelButton: true,
      })

      if (rejectReason) {
        rejectResellerHawala.mutate(rejectReason)
      }
    }
  }

  const setHawalaToUnderProcess = useMutation(() => setHawalaUnderProcess(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      toast.success('وضعیت به "در حال بررسی" تغییر یافت')
    },
    onError: () => {
      toast.error('تغییر وضعیت با خطا مواجه شد')
    },
  })

  const handleUnderProcess = async () => {
    const result = await Swal.fire({
      title: 'در حال بررسی؟',
      text: 'می‌خواهید وضعیت را به "در حال بررسی" تغییر دهید؟',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'بله، تغییر بده!',
    })

    if (result.isConfirmed) {
      setHawalaToUnderProcess.mutate()
    }
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-primary btn-active-light-primary'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
        style={{minWidth: '100px', fontSize: '11px'}}
      >
        <FormattedMessage id='TABLE.GENERAL.ACTION' />
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>

      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {status !== 'confirmed' && (
          <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={confirmingHawala}>
              <FormattedMessage id='TABLE.GENERAL.CONFIRM' />
            </a>
          </div>
        )}
        {['pending', 'underprocess'].includes(status) && (
          <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={confirmReject}>
              <FormattedMessage id='TABLE.GENERAL.REJECT' />
            </a>
          </div>
        )}
        {status !== 'confirmed' && (
          <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={confirmDelete}>
              <FormattedMessage id='TABLE.GENERAL.DELETE' />
            </a>
          </div>
        )}
        {status !== 'underprocess' && status !== 'confirmed' && (
          <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={handleUnderProcess}>
              <FormattedMessage id='TABLE.GENERAL.UNDERPROCESS' defaultMessage='در حال بررسی' />
            </a>
          </div>
        )}
      </div>
    </>
  )
}

export {HawalaActionsCell}
